/* 🤖 this file was generated by script */
export const wiconChevronRightDouble = {
  name: 'chevron_right_double',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 17l5-5-5-5m7 10l5-5-5-5"/></svg>`,
};
